<template>
    <div id="item-info-component" ref="item-info-component" v-on:click="exit">
        <picture>
            <source :srcset="$url + 'img/bg_acesso.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_acesso.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_acesso.webp'">
        </picture>
        <img id="raio" :src="$url + 'img/coleta/raios_desafio.png'">
        <img id="star" :src="$url + 'img/coleta/estrelas_desafio.png'">
        <img id="icon" :src="$url + 'img/coleta/icone_desafio.png'">
        <transition name="fade">
            <div v-if="show" id="box">
                <h3>Inventário de objetivos</h3>
                <span><a href="#"><img :src="$url + 'img/fechar.png'"></a></span>


                <br>
                <h4 v-if="(total_itens / itens.length) <= 3">
                    É isso aí, você está se saindo muito bem!<br><br>
                    Veja os itens que ainda faltam ser coletados, lembrando que existem 3 itens de
                    cada ameaça na 1ª fase, valendo cada um 10 pontos
                </h4>
                <h4 v-if="(total_itens / itens.length) > 3">
                    Defensor da cidade!<br><br>
                    Veja os itens que ainda faltam ser coletados, lembrando que existem 2 itens de
                    cada ameaça na 2a fase, valendo cada um 20 pontos
                </h4>
                <br>
                <ul>
                    <li v-for="(o, key) in itens_" v-bind:key="key">
                        <h3>{{ itens_name[key] }}</h3>
                        <br>
                        <img :src="$url  + 'img/itens/' + itens[key] + '.png'">
                        <br>
                        {{ o ? o : 0 }} de {{ total_itens / itens.length }}



                        <div class="wrapper">
                            <div class="progress-bar">
                                <div class="progress-bar-fill" :style="'width:' + (((o ? o : 0) / (total_itens / itens.length)) * 100) + '%'"></div>
                            </div>
                        </div>



                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
        name: "ItemInfoComponent",
        data() {
            return {
                itens_: [],
                show: false,
                total_itens: 0
            }
        },
        computed: {
            ...mapGetters(['item', 'itens', 'itens_ref', 'itens_frase', 'itens_name'])
        },
        methods: {
            start(_itens_, total_itens) {
                //_itens_ = que faltam ser pegos
                
                this.total_itens = total_itens;

                /*let a = [];
                for (let o in _itens_) {
                    let index = _itens_[o] ? this.itens_ref.indexOf(_itens_[o].name) : null;
                    if (index >= 0) {
                        if (a[index])
                            a[index]++;
                        else
                            a[index] = 1;
                    }
                }*/


               

                let a = [];
                for (let o in this.itens) {
                    a[o] = this.total_itens / this.itens.length;
                }

                //console.log(this.itens);
                //console.log('_itens_ -> ', _itens_);
                for (let o in _itens_) {
                    //console.log(_itens_[o].name);
                    let index = _itens_[o] ? this.itens_ref.indexOf(_itens_[o].name) : -1;
                    if (index >= 0) {
                        a[index]--;
                    }
                }

                this.itens_ = a;

                this.$parent.view_item_info = true;
                this.show = true;
            },
            yes() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.focusGame();
                this.$parent.view_item_info = false;
            },
            exit() {
                window.removeEventListener('keyup', this.keyUpEventHandler);
                this.$parent.focusGame();
                this.$parent.view_item_info = false;
            },
            keyUpEventHandler(e) {
                if (e.key == "Escape") {
                    this.exit();
                }
            }
        },
        mounted() {
            window.addEventListener('keyup', this.keyUpEventHandler);
        }
    }
</script>
<style scoped>
/*----- loader-bar -----*/
    .wrapper {
		width: 100%;
	}
			
	.progress-bar {
		width: 100%;
		background-color: #e0e0e0;
		padding: 3px;
		border-radius: 6px;
		box-shadow: inset 0 1px 3px rgba(0, 0, 0, .2);
	}
			
	.progress-bar-fill {
		display: block;
		height: 6px;
		background-color: #9dca26;
        border-radius: 3px;
				
		transition: width 500ms ease-in-out;
    }
    /*----- -----*/




    #bg
    {
        background-color: white;
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
        
    }
    #item-info-component {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: absolute;
        top: 100;
        width: 100%;
        
    }
    #raio
    {
        height: 701px;
        left: calc(50% - 350px);
        position: fixed;
        top: 100;
        width: 701px;
    }
    #star
    {
        height: 585px;
        left: calc(50% - 292px);
        position: fixed;
        top: 100;
        width: 585px;
    }
    #icon
    {
        height: 175px;
        left: calc(50% - 80px);
        position: fixed;
        top: 90px;
        width: 198px;
    }
    #box
    {
        background-color: #fff;
        border-bottom: solid 70px #9dca26;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: auto;
        left: calc(50% - 500px);
        margin-bottom: 50px;
        min-height: 400px;
        padding: 10px;
        position: absolute;
        text-align: center;
        top: 200px;
        width: 1000px;
    }
    #box > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        padding: 50px 10px 30px 10px;
    }


    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: 0 auto;
        padding: 15px;
        width: 180px;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }


    .fade-enter-active, .fade-leave-active {
        top: 200px;
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 250px;
        opacity: 0;
    }



    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 10%;
            width: 80%;
        }
    }
</style>